import {config, dom, library} from '@fortawesome/fontawesome-svg-core'
import {
	faAngleLeft,
	faAngleRight,
	faArrowLeft,
	faArrowRight,
	faArrowRightFromBracket,
	faArrowRotateBack,
	faBars,
	faBell,
	faCalendarDays,
	faCaretDown,
	faCaretUp,
	faChartColumn,
	faCheck,
	faCheckCircle,
	faCircle,
	faCircleHalfStroke,
	faClipboard,
	faClipboardCheck,
	faClipboardList,
	faCloudMoonRain,
	faCloudSunRain,
	faCodeMerge,
	faComment,
	faDatabase,
	faDownload,
	faEdit,
	faExclamation,
	faExpand,
	faFileCode,
	faFilePdf,
	faFilter,
	faFlag,
	faGear,
	faHand,
	faHandBackFist,
	faHeartPulse,
	faHelicopterSymbol,
	faHourglass,
	faHouseFire,
	faHouseMedical,
	faIdCard,
	faKey,
	faLocationCrosshairs,
	faLock,
	faLockOpen,
	faMagnifyingGlass,
	faMapLocationDot,
	faMasksTheater,
	faMinus,
	faMobileVibrate,
	faMoon,
	faNetworkWired,
	faNotdef,
	faPause,
	faPen,
	faPhone,
	faPlay,
	faPlus,
	faQrcode, faQuestionCircle,
	faRotate,
	faRss,
	faShield,
	faSun,
	faTableCellsRowLock,
	faTimesCircle,
	faTowerBroadcast,
	faTrash,
	faTruckMedical,
	faUser,
	faUserNurse,
	faUsers,
	faWrench,
	faXmark,
} from '@fortawesome/free-solid-svg-icons'

config.mutateApproach = 'sync';

library.add(
	faKey,
	faUser,
	faEdit,
	faTrash,
	faPlus,
	faCheckCircle,
	faTimesCircle,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faArrowRightFromBracket,
	faAngleRight,
	faAngleLeft,
	faWrench,
	faFilter,
	faBars,
	faBell,
	faSun,
	faMoon,
	faCircleHalfStroke,
	faGear,
	faUser,
	faUsers,
	faMapLocationDot,
	faNetworkWired,
	faTableCellsRowLock,
	faNotdef,
	faHouseMedical,
	faRotate,
	faCloudMoonRain,
	faCloudSunRain,
	faHourglass,
	faTruckMedical,
	faIdCard,
	faComment,
	faHouseFire,
	faPhone,
	faExclamation,
	faExpand,
	faCalendarDays,
	faUserNurse,
	faRss,
	faDatabase,
	faFlag,
	faClipboardList,
	faLocationCrosshairs,
	faMagnifyingGlass,
	faMobileVibrate,
	faHelicopterSymbol,
	faChartColumn,
	faMasksTheater,
	faDownload,
	faClipboard,
	faClipboardCheck,
	faQrcode,
	faHeartPulse,
	faFilePdf,
	faFileCode,
	faCircle,
	faShield,
	faCheck,
	faCaretDown,
	faCaretUp,
	faTowerBroadcast,
	faCodeMerge,
	faMinus,
	faHand,
	faHandBackFist,
	faArrowRotateBack,
	faLock,
	faLockOpen,
	faPen,
	faXmark,
	faQuestionCircle,
	faPause,
	faPlay
);

dom.watch();